import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import PdfIcon from "../Assets/img/pdf-icon.svg";
const ExamRoutine = () => {
  const [examRoutines, setExamRoutines] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get("JSON/classRoutine.json").then((response) => {
      setExamRoutines(response.data);
    });
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Exam Routine</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li>
                    <Link to="/examroutine">Academic Curriculum</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/examroutine">Exam Routine</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-class-routine eschool-exam-routine">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="eschool-class-routine-inner">
                {examRoutines?.map((classRoutine) => (
                  <div className="class-routine-card">
                    <div className="class-routine-icon">
                      <img src={PdfIcon} alt="#" />
                    </div>
                    <div className="class-routine-content">
                      <h4 className="class-routine-cont-title">
                        Class {classRoutine?.class}
                      </h4>
                      <div className="class-routine-btn">
                        <a
                          href={classRoutine?.file}
                          target="_blank"
                          className="btn-single view-btn"
                          rel="noreferrer"
                        >
                          View
                        </a>
                        <a
                          href={classRoutine?.file}
                          target="_blank"
                          className="btn-single dowload-btn"
                          download
                          rel="noreferrer"
                        >
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExamRoutine;
